import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { getTenantId } from "./AuthService";
import { SearchInvoiceDTO } from "@/model/data.model";
import { GetInvoiceResults, SearchParams } from "@/model/component.model";
import store from "../vuex/store";

export class BillingService {
  customerId: number;

  constructor(customerMbeId: string) {
    this.customerId = store.getters["customer/info"].customerId;
  }

  static getSearchableSalesTypes(): Promise<number[]> {
    let to_return: number[] = [];
    const config: AxiosRequestConfig = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/invoice/invoicing/sales_type/list",
      params: {
        tenantId: getTenantId()
      }
    };
    return axios.request(config).then((res: AxiosResponse) => {
      to_return = res.data
        .filter(
          (st: any) =>
            st.name == "Invoice" ||
            st.name == "Simplified Invoice" ||
            st.name == "Cumulative Invoice" ||
            st.name == "Debit Note" ||
            st.name == "Credit Note"
        )
        .map((st: any) => st.salesTypeId);
      return to_return;
    });
  }

  getInvoices(
    search: SearchParams = {
      search: "",
      page: 0,
      pageSize: 25
    } as SearchParams,
    salesTypeIds: number[] = [],
    dates
  ): Promise<GetInvoiceResults> {
    // First, get list of all invoices for this customer.
    const config: AxiosRequestConfig = {
      method: "POST",
      url:
        store.getters.BASE_API_URL + "/invoice/search/invoice-documents-search",
      params: {
        page: search.page,
        pageSize: search.pageSize,
        sortBy: "documentHead.saleDate desc"
      },
      data: {
        and: [
          {
            field: "documentHead.customerId",
            type: "INTEGER",
            operation: "=",
            values: [this.customerId]
          },
          {
            field: "active",
            type: "BOOLEAN",
            operation: "=",
            values: ["true"]
          },
          {
            field: "documentHead.salesTypeId",
            type: "CHOOSE_ANY_INTEGER",
            operation: "=",
            values: salesTypeIds
          }
        ]
      }
    };
    if (dates.dateStart) {
      const newDate =
        dates.dateStart.getTime() - dates.dateStart.getTimezoneOffset() * 60000;
      dates.dateStart = new Date(newDate);
      config.data.and.push({
        field: "documentHead.saleDate",
        type: "DATE",
        operation: ">=",
        values: [dates.dateStart.toISOString()]
      });
    }
    if (dates.dateEnd) {
      const newDate =
        dates.dateEnd.getTime() - dates.dateEnd.getTimezoneOffset() * 60000;
      dates.dateEnd = new Date(newDate);
      config.data.and.push({
        field: "documentHead.saleDate",
        type: "DATE",
        operation: "<=",
        values: [dates.dateEnd.toISOString()]
      });
    }

    return axios.request(config).then((res: AxiosResponse) => {
      const invoices = res.data.content as SearchInvoiceDTO[];
      const searchParams = {
        search: search.search,
        orderField: search.orderField,
        orderDirection: search.orderDirection,
        totalElements: res.data.totalElements,
        totalPages: res.data.totalPages,
        numberOfElements: res.data.numberOfElements,
        page: res.data.number,
        pageSize: res.data.size
      } as SearchParams;

      return { invoices, searchParams } as GetInvoiceResults;
    });
  }

  static printInvoices(storeId: number, documentsIds: string[]) {
    return axios({
      method: "POST",
      timeout: 60000,
      url:
        store.getters.BASE_API_URL +
        "/invoice/invoicing/print?invoiceDocumentType=MAIN,ATTACHMENT",
      data: {
        storeId: storeId,
        documentsId: documentsIds,
        notPrintAttachment: false
      }
    }).then(res => res.data);
  }
}
